/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { PanelCard } from '../../../design-system/molecules/PanelCard/PanelCard';
import type { TimelineStep } from '../../types';
import { toKstParts } from '../../utils/formatDateTime';
import {
  stepStyle,
  dotStyle,
  labelStyle,
  timeStyle,
  timeDateStyle,
  timeClockStyle,
  timeEmptyStyle,
  tzBadgeStyle,
  footnoteStyle,
} from './JobTimeline.styles';

export interface JobTimelineProps {
  steps: TimelineStep[];
  /** 단계 아래 요약 문구. 예: "대기 ~2s · 실행 약 2~3분" (선택) */
  footnote?: ReactNode;
}

/** 실행 타임라인. 생성→시작→종료 단계 시각 표시에 활용. 시각은 KST(UTC+9) 표기. */
export function JobTimeline({ steps, footnote }: JobTimelineProps) {
  return (
    <PanelCard title="실행 타임라인" headerRight={<span css={tzBadgeStyle}>KST · UTC+9</span>}>
      {steps.map((step, i) => {
        const kst = toKstParts(step.time);
        return (
          <div key={i} css={stepStyle}>
            <span css={dotStyle(step.done)} />
            <span css={labelStyle}>{step.label}</span>
            {kst ? (
              <span css={timeStyle}>
                <span css={timeDateStyle}>{kst.date} {kst.time}</span>
                {/*<span css={timeDateStyle}>{kst.date}</span>*/}
                {/*<span css={timeClockStyle}>{kst.time}</span>*/}
              </span>
            ) : (
              <span css={timeEmptyStyle}>—</span>
            )}
          </div>
        );
      })}
      {footnote !== undefined && <p css={footnoteStyle}>{footnote}</p>}
    </PanelCard>
  );
}
